"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoStyled = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var logoSizes = {
  // pill
  primary: {
    ratio: 0.281,
    sizes: {
      xs: '72px',
      sm: '92px',
      md: '120px',
      lg: '160px'
    }
  },
  // wordmark
  secondary: {
    ratio: 0.215,
    sizes: {
      xs: '72px',
      sm: '92px',
      md: '120px',
      lg: '160px'
    }
  },
  // square
  tertiary: {
    ratio: 1,
    sizes: {
      xs: '72px',
      sm: '92px',
      md: '120px',
      lg: '160px'
    }
  }
};
var LogoStyled = _styledComponents.default.svg.withConfig({
  displayName: "Logostyle__LogoStyled",
  componentId: "sc-1im8go-0"
})(["", ";"], function (_ref) {
  var logoType = _ref.logoType,
    size = _ref.size;
  var width = logoSizes[logoType].sizes[size];
  var heightVal = (0, _polished.stripUnit)(width) * logoSizes[logoType].ratio;
  var height = "".concat(Math.round(heightVal), "px");
  return (0, _styledComponents.css)(["width:", ";height:", ";"], width, height);
});
exports.LogoStyled = LogoStyled;